import React from 'react';
import { styled } from '@mui/material';

export const ButtonAreaWrapper = styled('div')({
  padding: '22px 35px'
});

export const ButtonAreaTitle = styled((props: any) => {
  return (<div {...props}>{props.title ? props.title : 'Fix Now'}</div>)
})(() => ({
  marginTop: '-33px',
  backgroundColor: '#fff',
  fontSize: '15px',
  width: '60px',
  padding: '0 10px'
}));

export const ButtonAreaContent = styled('div')({
  display: 'flex',
  marginTop: '12px',
  justifyContent: 'space-between',
  alignItems: 'center',
  flexDirection: 'column',
  '& > button': {
    minWidth: '200px',
    fontSize: '12px',
    margin: '5px auto 2px auto'
  }
});